import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    className={className}
    {...rest}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Tag = ({ children, className = "", light = false }) => (
  <p className={`inline-flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.18em] ${light ? "text-bone/60" : "text-ink/60"} ${className}`}>
    <span className={`h-1.5 w-1.5 ${light ? "bg-teal" : "bg-teal"}`} aria-hidden="true" />
    {children}
  </p>
);

export const Heading = ({ children, className = "", as: As = "h2", light = false }) => (
  <As className={`font-display font-semibold tracking-[-0.02em] leading-[0.95] ${light ? "text-bone" : "text-ink"} text-[2.4rem] sm:text-6xl lg:text-7xl ${className}`}>
    {children}
  </As>
);

export { EASE };
